<template>
  <div
    id="home_wrap"
    class="home_wrap"
  >
    <!-- 标头 -->
    <div
      id="red_top_bg"
      class="red_top_bg"
      style="z-index: 10000;background: rgba(0, 0, 0, 0.88) !important;color:fff"
    >
      <div
        class="logo"
        style="display: flex;
            align-items: center;
            gap: 10px;
            font-size: 16px;
            font-weight: 800;
            color: #fff;
            letter-spacing: -0.4px;"
      >
        <div
          class="logo-dot"
          style="width: 32px;
            height: 32px;
            border-radius: 9px;
            overflow: hidden;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;"
        >
          <img
            :src="logo"
            alt="logo"
            class="logo-dot-img"
            style="width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;"
          > 
        </div>
        {{ app.name }}
      </div>
      <div
        class="language"
        style="display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 6px;
    cursor: pointer;
    transition: opacity 0.2s;"
      >
        <img
          :src="require('../img/user/kf.png')"
          style=" width: 32px;
	      height: 32px;
	      object-fit: cover;
	      border-radius: 5px;
	      display: block;margin-right: 6px"
          @click="jump(service.kefu)"
        >
        <img
          :src="language_logo"
          style=" width: 32px;
            height: 32px;
            object-fit: cover;
            border-radius: 9px;
            display: block;"
          @click="$router.push('/language')"
        >
      </div>
    </div>
    <!-- 轮播图 -->
    <div
      class="swiper_container"
      style="margin-top: 80px;"
    >
      <van-swipe
        v-show="loading"
        :autoplay="2500"
        class="swiper-container"
      >
        <van-swipe-item
          v-for="(image, index) in banners"
          :key="index"
          @click="jump(image.url)"
        >
          <img :src="image.img">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      class="currency_tips"
      style="margin-top: 10px;"
    >
      {{ $t('utils.newzx') }}
    </div>
    <div class="block_div currency_wrap">
      <van-swipe
        style="height: 70px;"
        :autoplay="2000"
        vertical
        :show-indicators="false"
      >
        <van-swipe-item
          v-for="(item,index) in new_list"
          :key="index"
          @click="$router.push('article/'+item.id)"
        >
          <div class="currency_detail">
            <div style="width: 100%;font-size: 12px;line-height: 40px;color: #fff;font-weight: 600;text-align: left;vertical-align: middle;">
              <div style="width: 40px;margin-left: 10px;height: 40px;float: left">
                <img
                  :src="item.img"
                  alt=""
                  style="width: 40px;height: 40px;border-radius: 10px;"
                >
              </div>
              <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 80%;margin-left: 4px;height: 40px;float: right;text-align: left;;font-size: 12px;line-height: 40px;color: #fff;font-weight: 600;">
                {{ item.title }}
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    
		
    <div class="genre-scroll-wrap">
      <div class="genre-scroll">
        <span
          v-for="(tab,index) in tabs"
          :key="index"
          class="genre-tag"
          :title="tab.title"
          :class="{ active: tab.id === active }"
          @click="qiehuan(tab.id)"
        >{{ tab.title }}</span>
      </div>
    </div>
		
    <!-- 热门推荐 -->
    <div class="section-row">
      <h3>🔥 {{ $t('utils.hot') }}</h3>
      <span
        class="link"
        @click="$router.push('/faxian')"
      >{{ $t('utils.qb') }} →</span>
    </div>
    <div class="card-grid-2">
      <div
        v-for="item in hotDramas"
        :key="item.id"
        class="drama-card"
        @click="$router.push({ name: 'investOne', params: { code: item.id } })"
      >
        <div
          class="card-thumb"
          :class="item.bgClass"
        >
          <img
            :src="item.img"
            alt=""
            class="thumb-img"
            loading="lazy"
          >
          <div class="play-icon-overlay">
            <div class="circle">
              ▶
            </div>
          </div>
        </div>
        <div class="card-info">
          <h4>{{ item.title }}</h4>
          <div class="meta-text">
            <span>{{ item.genre }}</span>
            <span class="dot-sep" />
            <span>{{ item.rating }}</span>
          </div>
          <div
            class="meta-text"
            style="margin-top: 5px;"
          >
            <span>{{ $t('utils.ji') }}   {{ item.episodes }}</span>
          </div>
        </div>
      </div>
    </div>
		
    <!-- 排行榜 -->
    <div class="section-row">
      <h3>🏆{{ $t('utils.qqpxb') }}TOP 5</h3>
      <span
        class="link"
        @click="$router.push('/invest')"
      >{{ $t('utils.wzbd') }} →</span>
    </div>
    <div class="rank-list">
      <div
        v-for="(item, idx) in trendingList"
        :key="item.id"
        class="rank-item"
         @click="$router.push({ name: 'investOne', params: { code: item.id } })"
      >
        <span class="rank-num">{{ String(idx + 1).padStart(2, '0') }}</span>
        <div
          class="rank-thumb"
          :class="item.bgClass"
        >
          <img
            :src="item.img"
            alt=""
            class="thumb-img"
            loading="lazy"
          >
        </div>
        <div class="rank-info">
          <div class="rk-title">
            {{ item.title }}
          </div>
          <div
            class="rk-sub"
            style="margin-top: 5px;"
          >
            {{ item.genre }} 
          </div>
          <div
            class="rk-sub"
            style="margin-top: 5px;"
          >
            {{ $t('utils.ji') }}  {{ item.episodes }}
          </div>
        </div>
        <span class="rank-score">{{ item.rating }}</span>
      </div>
    </div>
		
    <!-- 新剧上线 -->
    <div class="section-row">
      <h3>🆕{{ $t('utils.newsx') }}</h3>
      <span
        class="link"
        @click="$router.push('/faxian')"
      >{{ $t('utils.qb') }} →</span>
    </div>
    <div class="card-grid-2">
      <div
        v-for="item in newDramas"
        :key="item.id"
        class="drama-card"
		 @click="$router.push({ name: 'investOne', params: { code: item.id } })"
      >
        <div
          class="card-thumb"
          :class="item.bgClass"
        >
          <img
            :src="item.img"
            alt=""
            class="thumb-img"
            loading="lazy"
          >
          <div class="play-icon-overlay">
            <div class="circle">
              ▶
            </div>
          </div>
        </div>
        <span class="new-badge">NEW</span>
        <div class="card-info">
          <h4>{{ item.title }}</h4>
          <div
            class="meta-text"
            style="margin-top: 5px;"
          >
            <span>{{ item.genre }}</span>
            <span class="dot-sep" />
            <span>{{ item.rating }}</span>
          </div>
          <div
            class="meta-text"
            style="margin-top: 5px;"
          >
            <span>{{ $t('utils.ji') }}  {{ item.episodes }}</span>
          </div>
        </div>
      </div>
    </div>
				
    <div style="width: 100%;height: 20px;" />
		
   
    <van-dialog
      v-model="show_tc"
      :confirm-button-text="$t('utils.confirm')"
    >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
    
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import {
		Swipe,
		SwipeItem,
		Progress,
		Dialog,
		Field,
		Popup,
		NoticeBar,
		Lazyload,
		Search
	} from "vant";

	Vue.use(Progress).use(Dialog).use(Field).use(Popup).use(NoticeBar).use(Lazyload).use(Search);

	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				language_logo: localStorage.getItem('language_logo'),
				logo: localStorage.getItem("logo2"),
				tabs: [{
						id: 0,
						title: this.$t('tabs.all')
					}
				
				],
				active: 0,
				empty: false,
				loading: false,
				finished: false,
				list: [],
				page: 1,
				listRows: 8,
				
				hotDramas: [
					
				],
				trendingList: [
					
				],
				newDramas: [
					
				],
				show_tc: false,
				tc_content: "",
				banners: [],
				service:[],
				isApp: true,
				new_list:[],
				times:60,
				goods:[],
				isBodongPaused: false,
				bodongTimer: null,
				bodongLastTime: null,
				bodongSpeed: 0.10,
				app: {
					"show": false,
					"name": "",
					"url": "",
					"logo": "",
				},
			};
		},
		created() {
			if (window.plus) {
				window.plus.navigator.setStatusBarBackground('#FFFFFF');
				window.plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('index');
		},
		mounted() {
			this.start();
		},
		beforeDestroy() {
			this.stopBodongScroll();
			this.stopTimesCountdown();
		},
		methods: {
			jump(url) {
				if (url.indexOf('http') == 0) {
					//console.log('http');
					window.location.href = url;
				} else {
					this.$router.push(url);
				}
			},
			start() {
				Fetch('/index/item_class').then((r) => {
					var tabs1 = [];
					r.data.classes.forEach(item => {
						tabs1.push({
							id: item.id,
							title: item.title,
						})
					})
					this.tabs = tabs1;
					this.qiehuan(0);
					this.show_tabs = true;
				});
				Fetch('/index/item_home', {
					page: this.page,
					listRows: this.listRows,
					type: this.active
				}).then(r => {
					
					this.hotDramas=r.data.list.hotDramas;
					this.trendingList=r.data.list.trendingList;
					this.newDramas=r.data.list.newDramas;
					
				});
				Fetch('/index/int').then((r) => {
					block: {
						if (r.data.popup.show == 1) {
							var popup_show = sessionStorage.getItem("popup_show");
							sessionStorage.setItem("popup_show", r.data.popup.num);
							if (popup_show != null && popup_show == 1) {
								break block;
							}
							this.tc_content = r.data.popup.content;
							this.show_tc = true;
						}
					}
					this.banners = r.data.banner;
					this.loading = true;
					this.app = r.data.version;
					this.new_list = r.data.new_list;
					this.service = r.data.service;
					this.showApp();
				});
				
				
			},
			initBodongScroll() {
				this.stopBodongScroll();
				const el = this.$refs.bodongScroll;
				if (!el || !el.scrollWidth) {
					return;
				}
				this.isBodongPaused = false;
				this.bodongLastTime = null;
				const step = (timestamp) => {
					if (this.isBodongPaused) {
						this.bodongLastTime = timestamp;
						this.bodongTimer = requestAnimationFrame(step);
						return;
					}
					if (this.bodongLastTime !== null) {
						const delta = (timestamp - this.bodongLastTime) * this.bodongSpeed;
						el.scrollLeft += delta;
						if (el.scrollLeft >= el.scrollWidth / 2) {
							el.scrollLeft -= el.scrollWidth / 2;
						}
					}
					this.bodongLastTime = timestamp;
					this.bodongTimer = requestAnimationFrame(step);
				};
				this.bodongTimer = requestAnimationFrame(step);
			},
			qiehuan(id){
				this.active = id;
				Fetch('/index/item_home', {
					page: this.page,
					listRows: this.listRows,
					type: this.active
				}).then(r => {
					
					this.hotDramas=r.data.list.hotDramas;
					this.trendingList=r.data.list.trendingList;
					this.newDramas=r.data.list.newDramas;
					//console(this.newDramas);
				});
			},
			stopBodongScroll() {
				if (this.bodongTimer) {
					cancelAnimationFrame(this.bodongTimer);
					this.bodongTimer = null;
				}
				this.bodongLastTime = null;
			},
			startTimesCountdown() {
				this.stopTimesCountdown();
				this.times = 60;
				this.countdownTimer = setInterval(() => {
					if (this.times > 0) {
						this.times -= 1;
					}
					if (this.times <= 0) {
						this.refreshBodongGoods();
					}
				}, 1000);
			},
			stopTimesCountdown() {
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
			},
			refreshBodongGoods() {
				Fetch('/index/goods').then((r) => {
					this.goods = r.data;
					this.$nextTick(() => {
						setTimeout(() => {
							this.initBodongScroll();
						}, 50);
					});
					this.times = 60;
				});
			},
			showApp() {
				if (window.plus) {
					this.isApp = true;
				} else {
					if (this.app.show) {
						this.isApp = false;
						document.getElementById('red_top_bg').style.top = '0px';
						document.getElementById('home_wrap').style.paddingTop = '0px';
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.home_wrap {
		margin-bottom: 60px;
		/* 给页面主体默认顶部内边距，避免固定头部遮挡内容 */
		padding-top: 68px;
		height: 100%;
		min-height: 100vh;
		background-color: var(--bg-primary);
		color: var(--text-primary);


	}

	.red_top_bg {
		position: fixed !important;
		top: 0;
		left: 0;
		right: 0;
		z-index: 100000 !important;
		height: 68px;
		padding: 10px 0;
		background: hsla(0, 0%, 100%, .96);
		border-bottom: 1px solid #edf0f6;
		box-shadow: 0 2px 14px rgba(35, 65, 112, .06);
		/* 确保不会被 transform/stacking context 覆盖 */
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		.logo {
			position: absolute;
			top: 10px;
			left: 3%;
			height: 48px;
		
			img {
				height: 100%;
			}
		}
		.language {
			position: absolute;
			top: 19px;
			right: 2%;
			height: 36px;
		
			img {
				height: 100%;
			}
		}
	}
	.swiper_container{
		// min-height: 182px;
		position: relative;
		//background: #FFFFFF;
	}
	.swiper-container {
		width: 100%;
		margin: 10px 0 0 0;
		

		.van-swipe-item {
			overflow: hidden;
		}

		img {
			border-radius: 20px;
			margin-left: 3%;
			height: 200px;
			width: 94%;
		}
	}


	.notice {
		margin-bottom: 10px;
	}
	
	.work_box {
		padding: 10px 15px 5px 15px;
		height: auto;
		margin-bottom: 15px;
		
		.flex_center {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
			justify-content: space-between;
		}
		
		.item {
			width: calc(33.333% - 4px);
			text-align: center;
			margin-bottom: 6px;
			flex: 0 0 calc(33.333% - 4px);
			display: flex;
			flex-direction: column;
			align-items: center;

			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				flex-shrink: 0;

				img {
					width: 34px;
					height: 34px;
					padding: 4px;
				}
			}

			.item_title {
				width: 100%;
				height: 20px;
				line-height: 14px;
				font-size: 13px;
				color: #fff;
				text-align: center;
				transform: scale(0.85);
				margin-top: 4px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}
	}

	.currency_wrap {
		
		margin-bottom: 15px;

		img {
			width: 40px;
		}

		.currency_detail {
			padding: 20px 0;
		}

		.currency {
			justify-content: space-around;

			p {
				font-size: 14px;
				font-weight: bold;
			}

			.logo {
				p {
					margin-left: 5px;
				}
			}

			.price {
				color: #3CB371;
				font-weight: bold;
			}
		}
	}

	.popup {
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
	
	.currency_tips{
		margin-bottom: 10px;
		margin-left: 3%;
		//border-left: 5px solid #0F6EFF;
		padding-left: 10px;
		font-size: 14px;
		font-weight: bold;
	}

	.currency_tips.aaa {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 3%;
	}

	.currency_tips.aaa .times {
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
		text-align: right;
		margin-left: auto;
		gap: 0;
	}

	.currency_tips.aaa .times1 {
		display: inline;
		min-width: 0;
		text-align: right;
		margin: 0;
		padding: 0;
	}
	
	.items {
		margin-bottom: 20px;
		
		.item {
			margin-bottom: 10px;
			

			.logo {
				position: relative;
				div{
					position: absolute;
					bottom: 0px;
					width: 100%;
					//background: #FFFFFF;
					height: 30px;
					line-height: 30px;
					opacity: 0.8;
					font-weight: bold;
					padding: 0 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				img {
					width: 100%;
					border-radius: 5px;
					max-height: 260px;
				}
			}

			.detail {
				padding: 15px;
				line-height: 2;

				.detail_num {
					font-weight: bold;
					color: #3CB371;
				}
			}
		}
	}

	.pub {
		text-align: center;
	}

	.pub div {
		display: block;
		width: fit-content;
		margin: 0 0 6px;
		text-align: left;
	}

	.bodong {
		width: 94%;
		margin: 0 auto 15px;
		padding: 8px 0;
		min-height: 170px;
		overflow: hidden;
		background: radial-gradient(circle at top right, rgba(212, 175, 55, .12), transparent 28%), linear-gradient(180deg, #0b0f14, #111821 34%, #0a1016);
		color: #fff;
		border-radius: 10px;
		box-sizing: border-box;
	}

	.bodong-scroll {
		display: flex;
		gap: 10px;
		overflow-x: auto;
		overflow-y: hidden;
		padding: 10px 12px;
		-webkit-overflow-scrolling: touch;
		touch-action: pan-x;
	}

	.bodong-scroll::-webkit-scrollbar {
		display: none;
	}

	.bodong-item {
		flex: 0 0 calc((100% - 20px) / 3);
		max-width: calc((100% - 20px) / 3);
		min-width: 130px;
		padding: 12px;
		border-radius: 12px;
		background: linear-gradient(180deg, hsla(0, 0%, 100%, .06), hsla(0, 0%, 100%, .03)), linear-gradient(135deg, rgba(212, 175, 55, .06), transparent);
		border: 0.5px solid rgba(212, 175, 55, .14);
		box-shadow: 0 7px 20px rgba(0, 0, 0, .18);
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.bodong1 {
		display: flex;
		align-items: center;
		gap: 8px;
		height: 30px;
		font-size: 14px;
		font-weight: 700;
	}

	.bodong1 img {
		width: 30px;
		height: 30px;
		object-fit: cover;
		border-radius: 50%;
	}

	.bodong-status {
		height: 52px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bodong-status img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}

	.bodong2 {
		font-size: 14px;
		font-weight: 700;
		margin-top: 8px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
	}

	.bodong3 {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 8px;
	}

	.text-down {
		color: #ff5a6f;
	}

	.text-up {
		color: #27c57a;
	}

	#download_app {
		position: fixed;
		background: #fff;
		width: 100%;
		top: 0;
		height: 60px;
		z-index: 11;
		justify-content: space-between;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
		padding: 0 20px 0 0;

		.app_close {
			color: #999;
			width: 50px;
			line-height: 60px;
			height: 60px;
			text-align: center;
		}

		.app_logo {
			margin-right:5px;
			img {
				height: 30px;
			}
		}

		.down_btn {
			padding: 0 15px;
			width: unset;
			height: 32px;
			line-height: 32px;
		}
	}
	/deep/.van-notice-bar{
		border-radius:  0 0 5px 5px;
	}
	.block_div{
		box-shadow: 0 0 80px rgba(0, 0, 0, 0.8);background: #141418 !important;
		
	}
	/* ========== 分类标签 ========== */
	        .genre-scroll-wrap {
	            padding: 0 16px;
	            margin-bottom: 8px;
	            overflow: hidden;
	        }
	        .genre-scroll {
	            display: flex;
	            flex-wrap: nowrap;
	            gap: 10px;
	            overflow-x: auto;
	            overflow-y: hidden;
	            scroll-behavior: smooth;
	            -webkit-overflow-scrolling: touch;
	            touch-action: pan-x;
	            -ms-overflow-style: none;
	            scrollbar-width: none;
	            padding: 8px 2px 12px;
	            white-space: nowrap;
	            width: 100%;
	        }
	        .genre-scroll::-webkit-scrollbar {
	            display: none;
	        }
	        .genre-tag {
	            flex: 0 0 auto;
	            flex-shrink: 0;
	            padding: 10px 20px;
	            border-radius: 22px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .genre-tag.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	            box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
	        }
	        .genre-tag:active {
	            transform: scale(0.95);
	        }
	
	        /* ========== 区块标题 ========== */
	        .section-row {
	            display: flex;
	            justify-content: space-between;
	            align-items: baseline;
	            padding: 20px 20px 12px;
	        }
	        .section-row h3 {
	            font-size: 14px;
	            font-weight: 700;
	            letter-spacing: -0.4px;
	            color: #fff;
	        }
	        .section-row .link {
	            font-size: 13px;
	            color: rgb(10, 168, 131);
	            font-weight: 600;
	            cursor: pointer;
	            letter-spacing: 0.01em;
	            transition: opacity 0.2s;
	        }
	        .section-row .link:active {
	            opacity: 0.6;
	        }
	
	        /* ========== 卡片网格 ========== */
	        .card-grid-2 {
	            display: grid;
	            grid-template-columns: repeat(2, 1fr);
	            gap: 16px;
	            padding: 0 16px;
	            margin-bottom: 12px;
	        }
	        .drama-card {
	            background: var(--bg-card);
	            border-radius: var(--radius-lg);
	            overflow: hidden;
	            cursor: pointer;
	            border: 1px solid var(--border);
	            transition: all 0.3s ease;
	            position: relative;
	            box-shadow: var(--shadow-card);
	        }
	        .drama-card:active {
	            transform: scale(0.96);
	            border-color: rgba(255, 255, 255, 0.18);
	            box-shadow: var(--shadow-elevated);
	        }
	        .card-thumb {
	            width: 100%;
	            aspect-ratio: 16 / 10;
	            position: relative;
	            overflow: hidden;
	        }
	        .thumb-img {
	            position: absolute;
	            top: 0;
	            left: 0;
	            width: 100%;
	            height: 100%;
	            object-fit: cover;
	            display: block;
	            transition: transform 0.4s ease;
	        }
	        .drama-card:active .thumb-img {
	            transform: scale(1.03);
	        }
	        .card-thumb .play-icon-overlay {
	            position: absolute;
	            inset: 0;
	            background: rgba(0, 0, 0, 0.4);
	            display: flex;
	            align-items: center;
	            justify-content: center;
	            opacity: 0;
	            transition: opacity 0.3s ease;
	            z-index: 2;
	        }
	        .drama-card:active .play-icon-overlay {
	            opacity: 1;
	        }
	        .play-icon-overlay .circle {
	            width: 40px;
	            height: 40px;
	            border-radius: 50%;
	            background: rgba(255, 255, 255, 0.95);
	            display: flex;
	            align-items: center;
	            justify-content: center;
	            font-size: 14px;
	            color: #000;
	            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	        }
	        .card-info {
	            padding: 12px 14px 14px;
	        }
	        .card-info h4 {
	            font-size: 14px;
	            font-weight: 600;
	            margin-bottom: 5px;
	            white-space: nowrap;
	            overflow: hidden;
	            text-overflow: ellipsis;
	            letter-spacing: -0.01em;
	            color: #fff;
	        }
	        .card-info .meta-text {
	            font-size: 12px;
	            color: var(--text-muted);
	            display: flex;
	            align-items: center;
	            gap: 7px;
	            font-weight: 500;
	        }
	        .card-info .meta-text .dot-sep {
	            width: 3px;
	            height: 3px;
	            background: var(--text-muted);
	            border-radius: 50%;
	        }
	        .new-badge {
	            position: absolute;
	            top: 10px;
	            left: 10px;
	            background: var(--accent);
	            color: #fff;
	            font-size: 10px;
	            font-weight: 700;
	            padding: 4px 10px;
	            border-radius: 12px;
	            z-index: 3;
	            letter-spacing: 0.04em;
	            text-transform: uppercase;
	        }
	
	        /* ========== 排行榜 ========== */
	        .rank-list {
	            display: flex;
	            flex-direction: column;
	            gap: 10px;
	            padding: 0 16px;
	            margin-bottom: 12px;
	        }
	        .rank-item {
	            display: flex;
	            align-items: center;
	            gap: 14px;
	            background: var(--bg-card);
	            border-radius: var(--radius-lg);
	            padding: 14px 16px;
	            cursor: pointer;
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            box-shadow: var(--shadow-card);
	        }
	        .rank-item:active {
	            background: #1a1a24;
	            border-color: rgba(255, 255, 255, 0.15);
	            transform: scale(0.98);
	        }
	        .rank-num {
	            font-size: 14px;
	            font-weight: 900;
	            color:#fff;
	            letter-spacing: -2px;
	            min-width: 42px;
	            text-align: center;
	            flex-shrink: 0;
	            font-variant-numeric: tabular-nums;
	        }
	        .rank-thumb {
	            width: 56px;
	            height: 56px;
	            border-radius: var(--radius-sm);
	            flex-shrink: 0;
	            position: relative;
	            overflow: hidden;
	            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
	        }
	        .rank-thumb .thumb-img {
	            position: absolute;
	            top: 0;
	            left: 0;
	            width: 100%;
	            height: 100%;
	            object-fit: cover;
	        }
	        .rank-info {
	            flex: 1;
	            min-width: 0;
	        }
	        .rank-info .rk-title {
	            font-size: 13px;
	            font-weight: 600;
	            margin-bottom: 4px;
	            white-space: nowrap;
	            overflow: hidden;
	            text-overflow: ellipsis;
	            letter-spacing: -0.01em;
	        }
	        .rank-info .rk-sub {
	            font-size: 12px;
	            color: var(--text-muted);
	            font-weight: 500;
	        }
	        .rank-score {
	            font-size: 13px;
	            font-weight: 700;
	            color: #fbbf24;
	            flex-shrink: 0;
	            letter-spacing: -0.02em;
	        }
</style>
